import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess304004Status: 'idle',
    startProcess304004Error: undefined as any,
    loadUserParamsProcess304004Status: 'idle',
    loadUserParamsProcess304004Error: undefined as any,

    process304004List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess304004 = createAsyncThunk('process304004Slice/startProcess304004', async ({ process304004 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess304004/`,
        prepareData(process304004),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess304004Status } = getState().process304004Slice
        return startProcess304004Status !== 'pending'
    }
})

export const loadUserParamsProcess304004 = createAsyncThunk('process304004Slice/loadUserParamsProcess304004', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess304004/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess304004Status } = getState().process304004Slice
        return loadUserParamsProcess304004Status !== 'pending'
    }
})

const Process304004Slice = createSlice({
    name: 'process304004Slice',
    initialState,
    reducers: {
        resetstartProcess304004: (state) => {
            state.job = undefined
            state.startProcess304004Error = undefined
        },
        resetstartProcess304004Error: (state) => {
            state.startProcess304004Error = undefined
        },
        resetloadUserParamsProcess304004: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess304004Error = undefined
        },
        resetloadUserParamsProcess304004Error: (state) => {
            state.loadUserParamsProcess304004Error = undefined
        },
        removeFromProcess304004ListById: (state, action) => {
            state.process304004List = state.process304004List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess304004ListByIds: (state, action) => {
            state.process304004List = state.process304004List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process304004List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess304004Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process304004List = []
            state.startProcess304004Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess304004.pending, (state) => {
            state.startProcess304004Status = 'pending'
            state.startProcess304004Error = undefined
        })
        builder.addCase(startProcess304004.fulfilled, (state, action) => {
            state.startProcess304004Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess304004.rejected, (state, action) => {
            state.startProcess304004Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess304004Error = action.error.message
            } else {
                state.startProcess304004Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess304004.pending, (state) => {
            state.loadUserParamsProcess304004Status = 'pending'
            state.loadUserParamsProcess304004Error = undefined
        })
        builder.addCase(loadUserParamsProcess304004.fulfilled, (state, action) => {
            state.loadUserParamsProcess304004Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess304004.rejected, (state, action) => {
            state.loadUserParamsProcess304004Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess304004Error = action.error.message
            } else {
                state.loadUserParamsProcess304004Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess304004,
    resetstartProcess304004Error,
    resetloadUserParamsProcess304004,
    resetloadUserParamsProcess304004Error,
    removeFromProcess304004ListById,
    removeFromProcess304004ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process304004Slice.actions
export default Process304004Slice.reducer
